module.exports = __webpack_public_path__ + "img/recruit.89fa2f71.jpg";